import { Tab } from '../../types'
import { Tractor, Trailer } from './trip.types'

export const tripTabs: Tab[] = [
  {
    id: 'active',
    label: 'Active',
  },
  {
    id: 'archive',
    label: 'Completed',
  },
]

export const createTripTabs: Tab[] = [
  {
    id: 'tractor',
    label: 'Tractor',
  },
  {
    id: 'trailer',
    label: 'Trailer',
  },
  {
    id: 'order',
    label: 'Order',
  },
]

export const tractors: Tractor[] = [
  { tractorId: '12345' },
  { tractorId: '23456' },
]

export const trailers: Trailer[] = [
  { trailerId: 'ABC12345' },
  { trailerId: 'ABC23456' },
]

export const tripTableHeaders: Tab[] = [
  { id: 'action', label: 'Action' },
  { id: 'task', label: 'Task' },
  { id: 'order', label: 'Order#' },
  { id: 'date', label: 'Date/Time' },
  { id: 'company', label: 'Company' },
  { id: 'status', label: 'Status' },
]
